import React from 'react';
import PropTypes from 'prop-types';

import { Liquid } from 'liquidjs/dist/liquid.browser.umd.js';

class LiquidInput extends React.Component {
  static propTypes = {
    liquidContext: PropTypes.object.isRequired,
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.object]).isRequired,

    onValidityChange: PropTypes.func.isRequired,
    onValueChange: PropTypes.func.isRequired
  }

  state = {
    error: null,
    preview: ''
  }

  componentDidMount() {
    this.updateLiquidPreview(this.props.value);
  }

  componentDidUpdate(previousProps) {
    if (this.props.value !== previousProps.value) {
      this.updateLiquidPreview(this.props.value);
    }
  }

  updateLiquidPreview(value) {
    const engine = new Liquid();
    engine.parseAndRender(value, this.props.liquidContext)
      .then((preview) => {
        this.setState({ preview, error: null });
        this.props.onValidityChange(true, this.props.name);
      })
      .catch((error) => {
        this.setState({ error: error.message });
        this.props.onValidityChange(false, this.props.name);
      });
  }

  handleValueChange = (event) => {
    const { value } = event.target;
    this.props.onValueChange(value, this.props.name);
  }

  render() {
    return (
      <React.Fragment>
        <input
          className="liquid-input form-control"
          value={this.props.value}
          onChange={this.handleValueChange}
        />

        <div
          className={`liquid-preview ${this.state.error ? 'error text-danger' : ''}`}
          name="preview"
        >
          Preview: {this.state.error || this.state.preview}
        </div>
      </React.Fragment>
    );
  }
}

export default LiquidInput;
